// extracted by mini-css-extract-plugin
export default {"container":"iba-z","heading":"jba-z","links":"kba-z","linkBtn":"lba-z","disabled":"mba-z","linkUppercaseBold":"nba-z","copy":"oba-z","subCopy":"pba-z"};